import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { PRIMARY_COLOR } from 'Config';

const CountdownTimer = ({ initialTime = 120, onTimeUp }) => {
    const [remainingTime, setRemainingTime] = useState(initialTime);

    useEffect(() => {
        const timer = setInterval(() => {
            setRemainingTime((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    onTimeUp?.();
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [onTimeUp]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    return (
        <Typography
            variant="body1"
            style={{
                marginBottom: '0.5rem',
                color: remainingTime <= 30 ? PRIMARY_COLOR : 'inherit'
            }}
        >
            Remaining Time: {formatTime(remainingTime)}
        </Typography>
    );
};

export default CountdownTimer;
